export default "__VITE_ASSET__Dq09dTbI__"